import can from '@/router/middleware/can'

import auth from '../../../middleware/auth'

export default [
  {
    path: '/settings/administration/swagger',
    name: 'SettingsSwagger',
    component: () =>
      import(
        /* webpackChunkName: "SettingsGlobal" */ '@/pages/settings/administration/swagger/SwaggerIndex'
      ),
    meta: {
      middleware: [can('isApiDocAccess'), auth],
      title: 'apiDocs',
      breadCrumb: [
        { text: 'settings' },
        { text: 'administration' },
        { text: 'apiDocs' }
      ]
    }
  }
]
